export enum VerifiedMethod {
    Manual = "M",
    VerifiedMultiple = "A",
    Scanned = "S",
    ZeroShipped = "Z",
    SubjectToCount = "C",
    MassRefusal = "R"
}